angular.module('app').factory('casinoProviderService', [
    'Restangular',
    'settings',
    function (Restangular, settings) {
        var restAngular = Restangular.withConfig(function (Configurer)
        {
            Configurer.setBaseUrl(settings.apiURL);
        });

        restAngular = restAngular.all("/CasinoProvider/");

        return {
            create: function (requestData) {
                return restAngular.
                    one("create").
                    post("", requestData)
            },
            getProviders: function (requestData) {
                return restAngular.
                    one("get").
                    customGET(param(requestData))
            },
            get: function (requestData) {
                return restAngular.
                one("getList").
                customGET(param(requestData))
            },
            edit: function (requestData) {
                return restAngular.
                    one("change").
                    post("", requestData)
            },
            deleteCategoryById: function (request) {
                var requestObject = {
                    name: request.id,
                    status: request.status === 'archive' ? 'published' : 'archive'
                };
                return restAngular.
                one("changeitem").
                customGET(param(requestObject))
            },
            toggleItemInactive: function (pageId, title) {
                var requestObject = {
                    name: pageId,
                    status: title !== 'Publish' ? "inactive" : "published"
                };
                return restAngular.
                one("changeitem").
                customGET(param(requestObject))
            },
            getSkinProviderByCategoryId: function (requestData) {
                return restAngular.
                one("getSkinProvidersByCategory").
                customGET(param(requestData))
            },
            setIcon: function (requestData) {
                return restAngular.
                one("seticon").
                post("", requestData)
            }
        }
    }
]);